/**
 * LMS My Achievements spot
 * Mockup: https://www.figma.com/proto/LlHPx5PfB6bTl2Yl43phMq/LXP
 * User story: https://dev.azure.com/gn-global-it/vs-cfa-digital-and-commercial-services-online/_workitems/edit/71620
 **/
import { DatatableFooter } from "../../Foundation/datatable-footer";
import { utils } from "../../Foundation";

export class MyAchievements {
    constructor(element) {
        this._refs = {
            el: element,
            filtersElem: element.querySelector('.cards__filters'),
            content: element.querySelector('.cards__contents'),
            currentPage: 1,
            state: {
                totalItems: 0,
                data: []
            },
            settings: {
                maxPages: 5,
                pageSize: {
                    current: 10,
                    values: [10, 25, 50]
                },
                translations: {
                    sorting: "Sorting"
                }
            },
            eventList: {
                onChangePageSize: (e) => {
                    this._onChangePageSize(e);
                },
                onPageItemClick: (e) => {
                    this._onPageItemClick(e);
                },
                onArrowClick: (e) => {
                    this._onArrowClick(e);
                }
            }
        }

        this._init();
    }

    async _init() {
        // fetch data from api
        await this._fetchDataFromApi();
        // Create sorting
        this._createSorting();
        // Create card items
        this._createCardItems();
        // Create footer
        this._createFooter();
    }

    async _fetchDataFromApi() {
        const apiUrl = this._refs.api_url;
        await fetch(apiUrl)
            .then((response) => response.json())
            .then((json) => {
                if(json) {
                    this._updateState(json);
                }
            }).catch( err => {
                console.error('Fetch data from API failed.');
                console.error('Error: ', err);
            });
    }

    _updateState(input_data) {
        if(input_data.data) {
            this._refs.state.data = [...this._refs.state.data, ...input_data.data];
            this._refs.state.totalItems = this._refs.state.data.length;
        }
    }

    _createCardItems() {
        // Set sort order
        this._setSortOrder();
        // Generate list of items
        const filteredList = this._filterListOfItems();
        let contentList = '';

        filteredList.forEach(item => {
            const cardItem = this.cardTemplate(item);
            contentList += cardItem;
        });

        // Insert card items
        this._refs.content.innerHTML = contentList;
    }

    _filterListOfItems() {
        let startItem = 0;
        let endItem = this._refs.settings.pageSize.current * this._refs.currentPage;
        // Set item start position
        if (this._refs.currentPage > 1) {
            startItem = this._refs.settings.pageSize.current * (this._refs.currentPage - 1);
        }
        // Filter the list to display 10 / 25 / 50 items
        const filterList = this._refs.state.data.filter(
            (data, i) => i < endItem && startItem <= i
        );
        return filterList;
    }

    cardTemplate(settings) {
        const templateSettings = {...settings};

        return this._generateGridView(templateSettings);
    }

    _generateGridView(settings) {
        // Add loyalty points
        let pointTemp = settings.points ? `
            <div class="card-points d-flex">
                <div class="btn-icon award"></div>
                <p>${settings.points.label}: ${settings.points.points}</p>
            </div>
        ` : '';

        // Style card item
        let statusStyle = settings.status.success ? 'success' : 'fail';

        // Expiery / retake test
        let expieryCard = settings.status.success ? `<div class="card-text">${settings.expieryDate.label}: ${settings.expieryDate.dateLabel}</div>` : `<a href="${settings.status.url}" target="_blank">${settings.status.label}</a>`

        return `
        <div class="card ${statusStyle}">
            <div class="card-image d-flex" style="background-image: url('${settings.image.url}');" aria-label="${settings.image.alt}">
            </div>
            <div class="card-contents d-flex justify-content-between flex-direction-column">
                <div class="card-top">
                    <div class="card-body">
                        <div class="card-title h5 bold-font">
                            <span>${settings.content.headline}</span>
                            <br>
                            <span>${settings.content.description}</span>
                        </div>
                        ${pointTemp}
                        <div class="card-text">${settings.courseDate.label}: ${settings.courseDate.dateLabel}</div>
                        ${expieryCard}
                    </div>
                </div>
                <div class="card-bottom">
                    <div class="card-footer d-flex flex-direction-column">
                        <div>Score</div>
                        <div class="scores h1 bold-font">${settings.scores.score}/${settings.scores.maxScore}</div>
                    </div>
                </div>
            </div>
        </div>
        `;
    }

    // Use Datatable footer
    _createFooter() {
        new DatatableFooter(this._refs);
    }

    // Sort cart items based on dates
    _createSorting() {
        // Create toggle sort asc/desc
        this._refs.content.setAttribute('data-order', 'desc');
        this._toggleSortingButton(this._refs.settings.translations.sorting, 'bar-chart-2-outline', (e) => this._sortItemsAscDesc(e));
    }

    _setSortOrder() {
        const order = this._refs.content.getAttribute('data-order');
        this._sort(order);
    };

    _sort(sortOrder) {
        this._refs.state.data.sort((a, b) => {
            // Fixed sort on the newest content
            const sortItemA = sortOrder === 'desc' ? a.courseDate['iso'] : b.courseDate['iso'];
            const sortItemB = sortOrder === 'desc' ? b.courseDate['iso'] : a.courseDate['iso'];
            if (sortItemB.toUpperCase() < sortItemA.toUpperCase()) {
                return -1;
            }
            if (sortItemB.toUpperCase() > sortItemA.toUpperCase()) {
                return 1;
            }
            return 0;
        });
    };

    _toggleSortingButton(label, icon, cb) {
        const
            oCon = utils.createElement('div', {
                'class': 'sort_container d-flex align-items-center',
                'tabindex': '0'
            }),
            oIcon = utils.createElement('i', {
                'class': `eva eva-${icon}`,
                'aria-hidden': 'true'
            }, oCon),
            oElem = utils.createElement('div', {
                'innerHTML': label
            }, oCon);

        this._refs.filtersElem.querySelector('.sort_elements').append(oCon);
        
        if(cb) cb(oCon);
    }

    /**
     * Event listeners 
     * **/
    _updateViewItems() {
        // Remove card items
        this._refs.content.innerHTML = '';
        // Set item order
        this._setSortOrder();
        // Create card items
        this._createCardItems();
        // Update footer
        this._refs.el.setAttribute('data-currentPage', this._refs.currentPage);
    }

    // Pagination
    _onChangePageSize(e) {
        this._refs.currentPage = 1;
        this._refs.settings.pageSize.current = Number(e.target.options[e.target.selectedIndex].value);
        this._updateViewItems();
    }

    _onPageItemClick(e) {
        this._refs.currentPage = parseInt(e.target.innerHTML);
        this._updateViewItems();
    }

    _onArrowClick(e) {
        // Direction
        if (e.target.classList.contains('is-left')) {
            this._refs.currentPage--;
        } else {
            this._refs.currentPage++;
        }
        this._updateViewItems();
    }

    // Sorting
    _sortItemsAscDesc(elem) {
        const toggleSort = () => {
            if(this._refs.content) {
                const currentOrder = this._refs.content.getAttribute('data-order') === 'asc' ? 'desc' : 'asc';
                elem.querySelector('i').classList.toggle('asc');
                this._refs.content.setAttribute('data-order', currentOrder);
                this._updateViewItems();
            }
        };
        elem.addEventListener('keyup', (e) => {
            if(e.key === 'Enter') {
                toggleSort();
            }
        })
        elem.addEventListener('click', () => {
            toggleSort();
        });
    };
}